export enum ReconciliationPayType {
  PLANNED = 'planned',
  ACTUAL = 'actual',
  CUSTOM = 'custom',
  SHIFT_RATE = 'shift_rate',
  NONE = 'none',
}

export type ReconciliationStatusValue = 'needs_attention' | 'reconciled'

export type DurationDiscrepancyApi =
  | 'LESS_THAN_5_MINUTES'
  | 'BETWEEN_5_AND_15_MINUTES'
  | 'BETWEEN_15_AND_30_MINUTES'
  | 'MORE_THAN_30_MINUTES'

export interface ClockInSummary {
  clockInTime?: string
  clockOutTime?: string
  clockInDuration?: number
}

export interface ReconciliationApiItem {
  _id: string
  startTime: string
  endTime: string
  subject?: { id: string; name: string; picture: string }
  instanceType: { id: string; name: string }
  plannedDuration: number
  siteShift: boolean
  teamMember: {
    id: string
    name: { first: string; last: string }
    picture: string
  }
  clockIn: ClockInSummary
  warnings: number
  status: ReconciliationStatusValue
}

export interface ReconciliationListApiResponse {
  data: ReconciliationApiItem[]
  pagination: {
    totalItems: number
    currentPage: number
    itemsPerPage: number
    totalPages: number
  }
}

export interface ReconciliationRowPayRate {
  amount: string
  unit: 'hour' | 'shift'
  label: string | null
}

export interface ReconciliationRowTime {
  startTime: string
  endTime: string
  durationMinutes: number
}

export interface ReconciliationRowReconciliation {
  payType: ReconciliationPayType
  customStartTime?: string
  customEndTime?: string
  paidMinutes: number
  payAmount: string
  payRateSnapshot: string | null
  payRateLabel: string | null
  reconciledAt: string
}

export interface ReconciliationRow {
  rotaInstanceId: string
  startTimeIso: string
  teamMemberId: string
  status: 'needs_attention' | 'reconciled'
  date: string
  teamMember: { id: string; name: string; avatarUrl: string | null }
  serviceUser: { id: string; name: string; avatarUrl: string | null } | null
  eventType: { id: string; name: string }
  plannedTime: ReconciliationRowTime
  actualTime: ReconciliationRowTime | null
  isCanceled: boolean
  durationDiscrepancy: number | null
  warningCount: number
  warnings: string[]
  payRate: ReconciliationRowPayRate | null
  hasShiftRate: boolean
  reconciliation: ReconciliationRowReconciliation | null
}

export type ReconciliationSortField =
  | 'startTime'
  | 'status'
  | 'teamMemberName'
  | 'instanceTypeId'
  | 'plannedDuration'

export interface ReconciliationFilters {
  startTime: string
  endTime: string
  status?: string[]
  teamMemberIds?: string[]
  serviceUserIds?: string[]
  eventTypeIds?: string[]
  durationDiscrepancy?: DurationDiscrepancyApi[]
  sortField?: ReconciliationSortField
  sortDir?: 1 | -1
  page?: number
  pageSize?: number
}

export interface ReconcilePayload {
  payType: ReconciliationPayType
  customStartTime?: string
  customEndTime?: string
  noPayReason?: string
  customPaidAmount?: string
}

export interface BulkReconcilePayload {
  items: Array<{ rotaInstanceId: string; teamMemberId: string }>
  payType: ReconciliationPayType
}
